/*=========================================================================================
  File Name: module-usertax-getters.js
  Description: UserTax Module Getters
  ----------------------------------------------------------------------------------------
  Project: MISA InvoiceBots
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
export default {
	IntructionVideoTotal: state => {
		return state.IntructionVideoTotal;
	},

	IsMinimized: state => {
		return state.IsMinimized;
	}
};
